import React from 'react';
import Shimmer from './Shimmer';

const NavbarShimmer = () => {
    return (
        <nav className="fixed w-full z-50 bg-white shadow-lg py-2">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between">
                    {/* Logo shimmer */}
                    <div className="flex-shrink-0">
                        <Shimmer className="h-12 w-32 rounded-lg"/>
                    </div>

                    {/* Desktop Navigation shimmer */}
                    <div className="hidden lg:flex items-center space-x-6">
                        {/* Nav items shimmers */}
                        {[1, 2, 3, 4].map((item) => (
                            <Shimmer
                                key={item}
                                className="h-8 w-24 rounded-lg"
                            />
                        ))}

                        {/* Contact button shimmer */}
                        <Shimmer className="h-10 w-32 rounded-xl"/>
                    </div>

                    {/* Mobile menu button shimmer */}
                    <div className="lg:hidden">
                        <Shimmer className="h-10 w-10 rounded-lg"/>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default NavbarShimmer;